import PropTypes from 'prop-types';
import { useForm, useWatch, FormProvider } from 'react-hook-form';
import { useNodeById } from '@/stores/analysisStore';
import LevelizationForm from '@/components/core/LevelizationForm';
import { ModuleSelect } from '@/components/core/form/ModuleSelect';
import debounce from 'debounce';

const WorkbenchPlotForm = ({ defaultValues, onSubmit }) => {
  const methods = useForm({ defaultValues });
  const { handleSubmit, control } = methods;
  const debouncedSave = debounce(() => handleSubmit(onSubmit)(), 10);

  const [nodeId, levelizeBy, levelizeUnit] = useWatch({
    control,
    name: ['nodeId', 'levelizeBy', 'levelizeUnit'],
    defaultValue: defaultValues,
  });

  const node = useNodeById(nodeId);

  return (
    <FormProvider {...methods}>
      <div className="group node">
        <form onChange={debouncedSave}>
          <div className="mt-2 grid grid-cols-2 gap-1">
            <ModuleSelect />
            <LevelizationForm node={node} levelizeBy={levelizeBy} levelizeUnit={levelizeUnit} />
          </div>
        </form>
      </div>
    </FormProvider>
  );
};

WorkbenchPlotForm.propTypes = {
  params: PropTypes.arrayOf(PropTypes.object),
  defaultValues: PropTypes.object,
  onSubmit: PropTypes.func,
};

export default WorkbenchPlotForm;
